module.exports = __webpack_public_path__ + "static/media/19_negro.d2a817bd.svg";